__turbopack_context__.v({
  "className": "zkM6KW_className",
  "variable": "zkM6KW_variable",
});
